import { CKBox } from '@clearkit/react';
import Grid from '@material-ui/core/Grid';
import ThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

import styles from './Bit.style';

const Bit = withStyles(styles)(
  ({ classes, children, padding = true, className, ...props }) => {
    const theme = (outerTheme) => ({
      ...outerTheme,
      titlePadding: padding ? 0 : 16,
    });

    return (
      <Grid item {...props}>
        <CKBox
          className={classnames(classes.root, className, {
            [classes.noPadding]: !padding,
          })}>
          <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </CKBox>
      </Grid>
    );
  },
);

const Title = ({ classes, children }) => (
  <div className={classes.title}>{children}</div>
);

const Actions = ({ classes, children }) => (
  <div className={classes.actions}>{children}</div>
);

const Header = ({ classes, children }) => (
  <div className={classes.header}>{children}</div>
);

Bit.propTypes = Title.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
};

Bit.Title = withStyles(styles)(Title);
Bit.Actions = withStyles(styles)(Actions);
Bit.Header = withStyles(styles)(Header);

export default withStyles(styles)(Bit);
